import { ButtonBase, IconButton } from "@mui/material";
import { WrenchIcon, XIcon } from "@phosphor-icons/react";
import dayjs from "dayjs";

import type { UsePurchaseBlockReturn } from "./tools/usePurchaseBlock";

interface DevToolsTriggerProps {
  isOpen: boolean;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  purchaseBlock: UsePurchaseBlockReturn;
}

export function DevToolsTrigger({
  isOpen,
  onClick,
  purchaseBlock: {
    isPurchaseAllowed,
    purchaseAllowedSecondsLeft,
    togglePurchaseBlock,
  },
}: DevToolsTriggerProps) {
  return (
    <div className="fixed right-2 bottom-2 z-100001 flex items-center gap-1">
      {isPurchaseAllowed && (
        <ButtonBase
          sx={{
            px: 1,
            py: 0.5,
            color: "var(--color-semantic-error-strong)",
            borderRadius: "var(--radius-2xl)",
            border: "1px solid var(--color-semantic-error-strong)",
            bgcolor: "var(--color-surface-neutral-medium)",
            boxShadow: "var(--shadow-2xl)",
          }}
          onClick={togglePurchaseBlock}
        >
          {dayjs
            .duration(purchaseAllowedSecondsLeft, "seconds")
            .format("mm:ss")}
        </ButtonBase>
      )}

      <IconButton
        sx={{
          p: 1.5,
          boxShadow: "var(--shadow-2xl)",
          bgcolor: "var(--color-surface-accent-strong)",
          "&:hover": { bgcolor: "var(--color-surface-accent-strong)" },
        }}
        aria-label="DevTools"
        onClick={onClick}
      >
        {isOpen ? (
          <XIcon className="text-white" />
        ) : (
          <WrenchIcon className="text-white" />
        )}
      </IconButton>
    </div>
  );
}
